/**
 * Created by Simone.Sacchi on 18/01/2017.
 */

"use strict";


module.exports = {

    WORD_SEPARATOR : "_",
    WS : "_",
    ENTER_KEY : 13,

    notification_type : {
        INFO : "info",
        SUCCESS : "success",
        ERROR : "danger"
    }

};